// import React from "react";
// import {
//   Paper,
//   Typography,
//   List,
//   ListItem,
//   ListItemText,
//   Box,
//   Chip,
//   Divider,
// } from "@mui/material";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";

// const getTypeColor = (type) => {
//   const key = String(type || "").toLowerCase();
//   if (key.includes("job")) {
//     return { bg: "rgba(108, 99, 255, 0.12)", fg: "#4f46e5" };
//   }
//   if (key.includes("candidate")) {
//     return { bg: "rgba(0, 191, 174, 0.12)", fg: "#00897b" };
//   }
//   if (key.includes("email") || key.includes("notification")) {
//     return { bg: "rgba(25, 118, 210, 0.12)", fg: "#1565c0" };
//   }
//   return { bg: "rgba(107, 114, 128, 0.10)", fg: "#374151" };
// };

// export default function RecentActivityFeed({ activities = [] }) {
//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2.5,
//         mb: 3,
//         borderRadius: 2,
//         bgcolor: "#ffffff",
//         boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           mb: 1.5,
//           display: "flex",
//           alignItems: { xs: "flex-start", sm: "center" },
//           justifyContent: "space-between",
//           gap: 1,
//           flexWrap: "wrap",
//         }}
//       >
//         <Box>
//           <Typography
//             variant="overline"
//             sx={{
//               fontSize: 11,
//               letterSpacing: 0.8,
//               textTransform: "uppercase",
//               color: "text.secondary",
//             }}
//           >
//             Activity
//           </Typography>
//           <Typography
//             variant="h6"
//             sx={{ fontWeight: 700, lineHeight: 1.2 }}
//           >
//             Recent Activity
//           </Typography>
//         </Box>
//         {activities.length > 0 && (
//           <Typography
//             variant="caption"
//             color="text.secondary"
//             sx={{ whiteSpace: "nowrap" }}
//           >
//             {activities.length} item{activities.length > 1 ? "s" : ""}
//           </Typography>
//         )}
//       </Box>

//       <Divider sx={{ mb: 1.5 }} />

//       <Box
//         sx={{
//           flex: 1,
//           overflowY: "auto",
//           maxHeight: { xs: 260, sm: 320, md: 360 },
//         }}
//       >
//         <List dense disablePadding>
//           {activities.length === 0 ? (
//             <ListItem sx={{ px: 0 }}>
//               <ListItemText
//                 primaryTypographyProps={{ variant: "body2", color: "text.secondary" }}
//                 primary="No recent activity."
//               />
//             </ListItem>
//           ) : (
//             activities.map((a) => {
//               const colors = getTypeColor(a.type);
//               return (
//                 <ListItem
//                   key={a.id}
//                   alignItems="flex-start"
//                   sx={{
//                     px: 0,
//                     py: 1,
//                     "&:not(:last-of-type)": {
//                       borderBottom: "1px solid",
//                       borderColor: "rgba(229,231,235,0.6)",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary={
//                       <Typography
//                         variant="body2"
//                         sx={{ fontWeight: 500 }}
//                       >
//                         {a.description}
//                       </Typography>
//                     }
//                     secondary={
//                       <Box
//                         sx={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                           mt: 0.5,
//                           gap: 1,
//                           flexWrap: "wrap",
//                         }}
//                       >
//                         <Chip
//                           label={a.type}
//                           size="small"
//                           sx={{
//                             borderRadius: 999,
//                             height: 22,
//                             fontSize: 11,
//                             fontWeight: 600,
//                             bgcolor: colors.bg,
//                             color: colors.fg,
//                           }}
//                         />
//                         <Box
//                           sx={{
//                             display: "inline-flex",
//                             alignItems: "center",
//                             gap: 0.5,
//                             color: "text.secondary",
//                             fontSize: 12,
//                           }}
//                         >
//                           <AccessTimeIcon sx={{ fontSize: 14 }} />
//                           <span>
//                             {new Date(a.timestamp).toLocaleString()}
//                           </span>
//                         </Box>
//                       </Box>
//                     }
//                     secondaryTypographyProps={{ component: "div" }}
//                   />
//                 </ListItem>
//               );
//             })
//           )}
//         </List>
//       </Box>
//     </Paper>
//   );
// }


import React from "react";
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Chip,
  Divider,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const getTypeColor = (type, dark, accent) => {
  const key = String(type || "").toLowerCase();

  if (key.includes("job")) {
    return {
      bg: dark ? alpha(accent, 0.16) : alpha(accent, 0.10),
      fg: accent,
      border: alpha(accent, 0.22),
    };
  }

  if (key.includes("candidate")) {
    return {
      bg: dark ? "rgba(6,182,212,0.18)" : "rgba(6,182,212,0.10)",
      fg: dark ? "#67e8f9" : "#0f766e",
      border: dark ? "rgba(6,182,212,0.24)" : "rgba(6,182,212,0.18)",
    };
  }

  if (key.includes("email") || key.includes("notification")) {
    return {
      bg: dark ? "rgba(59,130,246,0.18)" : "rgba(59,130,246,0.10)",
      fg: dark ? "#93c5fd" : "#1d4ed8",
      border: dark ? "rgba(59,130,246,0.24)" : "rgba(59,130,246,0.18)",
    };
  }

  return {
    bg: dark ? "rgba(255,255,255,0.05)" : "rgba(15,15,26,0.03)",
    fg: dark ? "#cbd5e1" : "#374151",
    border: dark ? "rgba(255,255,255,0.08)" : "rgba(15,15,26,0.08)",
  };
};

export default function RecentActivityFeed({ activities = [] }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.75,
        borderRadius: "22px",
        background: dark ? "rgba(13,18,32,0.96)" : "rgba(255,255,255,0.98)",
        border: `1px solid ${border}`,
        boxShadow: dark
          ? "0 20px 50px rgba(0,0,0,0.20)"
          : "0 12px 30px rgba(15,23,42,0.06)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          mb: 1.75,
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: 11,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              color: muted,
              fontWeight: 500,
              fontFamily:
                '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
            }}
          >
            Activity
          </Typography>

          <Typography
            sx={{
              mt: 0.6,
              fontWeight: 800,
              fontSize: "1.35rem",
              lineHeight: 1.15,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            Recent Activity
          </Typography>
        </Box>

        {activities.length > 0 && (
          <Typography
            sx={{
              fontSize: "12px",
              color: muted,
              whiteSpace: "nowrap",
            }}
          >
            {activities.length} item{activities.length > 1 ? "s" : ""}
          </Typography>
        )}
      </Box>

      <Divider sx={{ mb: 1.5, borderColor: border }} />

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          maxHeight: { xs: 280, sm: 340, md: 380 },
        }}
      >
        <List dense disablePadding>
          {activities.length === 0 ? (
            <ListItem sx={{ px: 0 }}>
              <ListItemText
                primaryTypographyProps={{
                  sx: { color: mid, fontSize: "14px" },
                }}
                primary="No recent activity."
              />
            </ListItem>
          ) : (
            activities.map((a) => {
              const colors = getTypeColor(a.type, dark, accent);

              return (
                <ListItem
                  key={a.id}
                  alignItems="flex-start"
                  sx={{
                    px: 0,
                    py: 1.2,
                    "&:not(:last-of-type)": {
                      borderBottom: `1px solid ${border}`,
                    },
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: text,
                          lineHeight: 1.65,
                        }}
                      >
                        {a.description}
                      </Typography>
                    }
                    secondary={
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 0.8,
                          gap: 1,
                          flexWrap: "wrap",
                        }}
                      >
                        <Chip
                          label={a.type}
                          size="small"
                          sx={{
                            borderRadius: 999,
                            height: 24,
                            fontSize: 11,
                            fontWeight: 700,
                            bgcolor: colors.bg,
                            color: colors.fg,
                            border: `1px solid ${colors.border}`,
                          }}
                        />

                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 0.55,
                            color: mid,
                            fontSize: 12,
                          }}
                        >
                          <AccessTimeIcon sx={{ fontSize: 14 }} />
                          <span>{new Date(a.timestamp).toLocaleString()}</span>
                        </Box>
                      </Box>
                    }
                    secondaryTypographyProps={{ component: "div" }}
                  />
                </ListItem>
              );
            })
          )}
        </List>
      </Box>
    </Paper>
  );
}